module.exports = __webpack_public_path__ + "img/ico-house-green.04750fb3.svg";